import React from 'react';

const SkeletonArray = ({ length, children }: { length: number; children: React.ReactNode }) => (
  <>
    {Array.from(
      {
        length,
      },
      (_, i) => (
        <React.Fragment key={i}>{children}</React.Fragment>
      ),
    )}
  </>
);

export default SkeletonArray;
